import axios from "axios";
import { datadogRum } from "@datadog/browser-rum";

import { CorpBusinessAccountResponse } from "redmond/apis/tysons/businesses";
import { config } from "../../config";
import { cotbApiPrefix } from "../../paths";

const END_POINT: string = `${cotbApiPrefix}/listBusinessAccounts`;

export const fetchBusinessAccounts = (): Promise<CorpBusinessAccountResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(
        END_POINT,
        {},
        {
          baseURL: config.baseURL,
        }
      );
      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });

export const pollUntilAllOptedIn = async (
  maxAttempts = 8,
  delayMs = 500
): Promise<CorpBusinessAccountResponse> => {
  const startTime = performance.now();

  const poll = async (attempt: number): Promise<CorpBusinessAccountResponse> => {
    const accounts = await fetchBusinessAccounts();
    const allOptedIn = accounts.length > 0 && accounts.every((acc) => acc.optedIn);

    if (allOptedIn) {
      const duration = (performance.now() - startTime) / 1000;
      datadogRum.addAction("accountOptInPollingComplete", {
        duration,
        attempts: attempt + 1,
        result: "success",
        totalAccounts: accounts.length,
      });
      return accounts;
    }

    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, delayMs));
      return poll(attempt + 1);
    }

    const duration = (performance.now() - startTime) / 1000;
    const optedInCount = accounts.filter((acc) => acc.optedIn).length;

    datadogRum.addAction("accountOptInPollingComplete", {
      duration,
      attempts: maxAttempts,
      result: "timeout",
      totalAccounts: accounts.length,
      optedInAccounts: optedInCount,
      notOptedInAccounts: accounts.length - optedInCount,
    });

    return accounts;
  };

  return poll(0);
};
